import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description HandRight icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { HandRight } from '@sravni/design-system-icons'
 *
 * <HandRight />
 * ```
 */
var HandRight = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "HandRight", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16 13.202h4.5a1.5 1.5 0 0 0 0-3H12l1.494-2.987a1.571 1.571 0 0 0-2.597-1.725l-4.415 5.15A1.998 1.998 0 0 0 6 11.942v5.47A2 2 0 0 0 7.779 19.4l5.294.588a2 2 0 0 0 2.201-1.705L16 13.202Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M5 19.202H3a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { HandRight };
//# sourceMappingURL=HandRight.js.map
